import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Check, Pencil } from "lucide-react";
import { Shell } from "@/components/Shell";
import { getSections, visibleQuestions, formatAnswer } from "@/data/questionnaire";
import { getSubmission, upsertSubmission } from "@/lib/storage";
import { contributeAllQuiet } from "@/data/benchmark";

export default function SummaryPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sub] = useState(() => getSubmission(id));

  useEffect(() => {
    if (!sub) navigate("/", { replace: true });
  }, [sub, navigate]);
  if (!sub) return null;
  const SECTIONS = getSections(sub.businessType);

  const confirm = () => {
    upsertSubmission({ ...sub, status: "completed", completedAt: new Date().toISOString(), report: "", reportDone: false });
    contributeAllQuiet();
    navigate(`/grazie/${id}`, { replace: true });
  };

  return (
    <Shell header={<span className="text-sm text-[#7A6B63]">{sub.respondent}</span>}>
      <div className="fade-up">
        <p className="eyebrow">Ultimo passaggio</p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2C221E] mt-2">Rileggete le risposte</h1>
        <p className="text-[#5C4D46] mt-3">Potete correggere qualsiasi sezione. Quando è tutto a posto, confermate.</p>

        <div className="mt-10 grid gap-6">
          {SECTIONS.map((s, si) => (
            <div key={s.id} className="card p-6 sm:p-8" data-testid={`summary-section-${s.id}`}>
              <div className="flex items-start justify-between gap-4 mb-4">
                <h2 className="font-serif text-2xl font-semibold text-[#2D4030]">{s.title}</h2>
                <button className="btn btn-ghost !min-h-[44px] !px-4 text-sm" onClick={() => navigate(`/compila/${id}?s=${si}&from=riepilogo`)} data-testid={`summary-edit-btn-${si + 1}`}>
                  <Pencil size={16} /> Modifica
                </button>
              </div>
              <dl className="grid gap-4">
                {visibleQuestions(s, sub.answers).map((q) => {
                  const a = formatAnswer(q, sub.answers[q.id]);
                  return (
                    <div key={q.id}>
                      <dt className="text-sm text-[#7A6B63]">{q.text}</dt>
                      <dd className={`mt-1 text-base sm:text-lg ${a ? "text-[#2C221E]" : "italic text-[#B0A096]"}`} data-testid={`summary-answer-${q.id}`}>{a || "Non risposto"}</dd>
                    </div>
                  );
                })}
              </dl>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 justify-between mt-10">
          <button className="btn btn-ghost" onClick={() => navigate(`/compila/${id}?s=${SECTIONS.length - 1}`)} data-testid="summary-back-btn">
            <ArrowLeft size={18} /> Indietro
          </button>
          <button className="btn btn-primary text-lg !min-h-[64px] !px-9" onClick={confirm} data-testid="submit-survey-btn">
            <Check size={20} /> Conferma e consegna
          </button>
        </div>
      </div>
    </Shell>
  );
}
